import React from 'react';

const MenuIcon = ({ ...rest }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M7 9H25.4167M7 15.5H25.4167M7 22H25.4167" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>

  );
};

export default MenuIcon;